import React from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import JSZip from 'jszip';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import formatMoney from '../../utils/formatMoney';
import * as apiActions from '../../actions/api';
import invoiceDataSelector from '../../selectors/invoice';
import './styles.css';

const InvoiceTile = () => {
  const selectorData = useSelector(invoiceDataSelector);
  const {
    amountDue,
    remainingBalance,
    dueDate,
    files,
    invoiceItems,
    pastPayments,
    createdDate,
  } = selectorData;
  return (
    <Card className="invoice-tile-root">
      <CardContent>
        <div className="invoice-top-section">
          <div className="space-between-column">
            <div className="tile-header-text">
              Your Invoice Details
            </div>
            <div>
              <Typography className="invoice-date-label" color="textSecondary">
                Invoice Date
              </Typography>
              <div className="invoice-date">
                {format(new Date(createdDate), 'MMMM dd, yyyy')}
              </div>
            </div>
          </div>
          <List className="button-bar">
            <ListItem className="invoice-view-btn">
              {files.length > 0 && (
                <Button
                  onClick={() => {
                    if (files.length > 1) {
                      const zip = new JSZip();
                      for (let i = 0; i < files.length; i += 1) {
                        zip.file(files[i].name, apiActions.getFile(files[i].href));
                      }
                      zip.generateAsync({ type: 'blob', compression: 'STORE' }).then((blobZip) => {
                        const zipFile = URL.createObjectURL(blobZip);
                        window.open(zipFile, '_blank');
                      });
                    } else {
                      apiActions.getFile(files[0].href).then((resp) => {
                        const respFileURL = URL.createObjectURL(resp);
                        window.open(respFileURL, '_blank');
                      });
                    }
                  }}
                  variant="contained"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#289428',
                    color: '#fff',
                    fontSize: 14,
                  }}
                >
                  {files.length <= 1 ? 'View Attachment' : 'Download Attachments'}
                </Button>
              )}
            </ListItem>
          </List>
        </div>
        <Divider light />
        <div className="balance-due-section">
          <div>
            <Typography className="balance-due-label" color="textSecondary">
              Balance Due
            </Typography>
            <div className="balance-due">
              {formatMoney(remainingBalance)}
            </div>
          </div>
          <div>
            <Typography className="balance-due-label" color="textSecondary">
              Due Date
            </Typography>
            <div className="balance-due">
              {dueDate}
            </div>
          </div>
        </div>
        <Divider light />
        <List>
          <ListItem className="space-between">
            <div className="product-services-label">
              <b>Products &amp; Services</b>
            </div>
            <div />
          </ListItem>
          {
            Object.entries(invoiceItems).map((entries) => {
              const itemName = entries[0];
              const itemAmount = entries[1];
              return (
                <ListItem key={`${itemName}-${itemAmount}`}>
                  <div className="space-between">
                    <div className="invoice-item">{itemName}</div>
                    <div>{formatMoney(itemAmount)}</div>
                  </div>
                </ListItem>
              );
            })
          }
          <br />
          <ListItem>
            <div className="sub-total-list">
              <div><b>Total</b></div>
              <div>{formatMoney(amountDue)}</div>
            </div>
          </ListItem>
          {
            pastPayments.map((item) => (
              <ListItem key={item.transaction_id} className="sub-total-list">
                <div>{`Payment on ${format(new Date(item.transaction_date), 'MMMM dd, yyyy')}`}</div>
                <div>{`-${formatMoney(item.transaction_amount)}`}</div>
              </ListItem>
            )).reverse()
          }
          <br />
          <ListItem>
            <div className="space-between">
              <div><b>Remaining Balance</b></div>
              <div><b>{formatMoney(remainingBalance)}</b></div>
            </div>
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
};

export default InvoiceTile;
